(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('node-fetch')) :
  typeof define === 'function' && define.amd ? define(['exports', 'node-fetch'], factory) :
  (global = global || self, factory(global.halSDK = {}, global.req));
}(this, function (exports, req) { 'use strict';

  req = req && req.hasOwnProperty('default') ? req['default'] : req;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var HALPropertyMetadata = function HALPropertyMetadata(key, options) {
    _classCallCheck(this, HALPropertyMetadata);

    this.key = key;
    this.metadata = options && options.properties && options.properties[key] || undefined;
    this.required = options && options.required && options.required.find(function (prop) {
      return prop === key;
    }) && true;
  };

  var HALAction = function HALAction(apiAction) {
    _classCallCheck(this, HALAction);

    this.title = apiAction.title;
    this.method = apiAction.method;
    this.href = apiAction.href;
    this.rel = apiAction.rel;
    this.schema = apiAction.schema;
    this.propertiesMetadata = getPropertiesMetadata(apiAction.schema);
  };

  function getPropertiesMetadata(schema) {
    return schema && schema.properties && Object.keys(schema.properties).map(function (prop) {
      return new HALPropertyMetadata(prop, schema);
    }) || [];
  }

  var HALItem = function HALItem(apiItem) {
    _classCallCheck(this, HALItem);

    this.href = apiItem.href;
    this.summary = apiItem.summary;
  };

  var HALLink = function HALLink(apiLink, rel) {
    _classCallCheck(this, HALLink);

    this.rel = rel;
    this.href = apiLink.href;
  };

  var HALProperty = function HALProperty(key, value) {
    _classCallCheck(this, HALProperty);

    this.key = key;
    this.value = value;
  };

  function composeResource(_ref) {
    var body = _ref.body,
        options = _ref.options;
    return Object.assign({}, body, {
      _options: options || body && body._options || {}
    });
  }
  function getLinkByRel(_ref2) {
    var rel = _ref2.rel,
        links = _ref2.links;
    return links && links.find(function (link) {
      return link.rel === rel;
    }) || null;
  }
  function getItemByNumber(_ref3) {
    var items = _ref3.items,
        number = _ref3.number;
    return items[number];
  }
  function getItemsByFunction(_ref4) {
    var items = _ref4.items,
        callback = _ref4.callback;
    return items.filter(callback);
  }
  function getItemByFunction(_ref5) {
    var items = _ref5.items,
        callback = _ref5.callback;
    return items.find(callback);
  }
  function getProperty(_ref6) {
    var properties = _ref6.properties,
        key = _ref6.key;
    return properties.find(function (property) {
      return property.key === key;
    });
  }
  function getPropertyMetadata(_ref7) {
    var propertiesMetadata = _ref7.propertiesMetadata,
        key = _ref7.key;
    return propertiesMetadata.find(function (property) {
      return property.key === key;
    });
  }
  function getActionByRel(_ref8) {
    var rel = _ref8.rel,
        actions = _ref8.actions;
    return actions.find(function (action) {
      return action.rel === rel;
    });
  }
  function getActionsByMethod(_ref9) {
    var method = _ref9.method,
        actions = _ref9.actions;
    return actions.filter(function (action) {
      return action.method === method;
    });
  }
  function getItems(resp) {
    var respItems = resp._links && resp._links.item && (Array.isArray(resp._links.item) && resp._links.item || [resp._links.item]) || [];
    return respItems.map(function (item) {
      return new HALItem(item);
    });
  }
  function getLinks(resp) {
    return resp._links && Object.keys(resp._links).filter(function (key) {
      return key !== "item";
    }).map(function (key) {
      return new HALLink(resp._links[key], key);
    });
  }
  function getActions(resp) {
    var respActions = resp._options && resp._options.links || [];
    return respActions.map(function (action) {
      return new HALAction(action);
    });
  }
  function getProperties(resp) {
    return Object.keys(resp).filter(function (key) {
      return key !== "_embedded" && key !== "_options" && key !== "_links";
    }).map(function (key) {
      return new HALProperty(key, resp[key]);
    });
  }
  function getPropertiesMetadata$1(resp) {
    var respProperties = resp && resp._options && resp._options.properties || {};
    return Object.keys(respProperties).map(function (key) {
      return new HALPropertyMetadata(key, resp._options);
    });
  }
  function getTitle(resp) {
    return resp && resp._options && resp._options.title || "";
  }

  function halResource(_ref) {
    var body = _ref.body,
        options = _ref.options;
    var resourceRepresentation = composeResource({
      body: body,
      options: options
    });
    var actions = getActions(resourceRepresentation);
    var links = getLinks(resourceRepresentation);
    var items = getItems(resourceRepresentation);
    var properties = getProperties(resourceRepresentation);
    var propertiesMetadata = getPropertiesMetadata$1(resourceRepresentation);
    return {
      resourceRepresentation: resourceRepresentation,
      actions: actions,
      items: items,
      links: links,
      properties: properties,
      propertiesMetadata: propertiesMetadata,
      getActionByRel: function getActionByRel$$1(rel) {
        return getActionByRel({
          rel: rel,
          actions: actions
        });
      },
      getActionsByMethod: function getActionsByMethod$$1(method) {
        return getActionsByMethod({
          method: method,
          actions: actions
        });
      },
      getItemByFunction: function getItemByFunction$$1(callback) {
        return getItemByFunction({
          callback: callback,
          items: items
        });
      },
      getItemByNumber: function getItemByNumber$$1(number) {
        return getItemByNumber({
          number: number,
          items: items
        });
      },
      getItemsByFunction: function getItemsByFunction$$1(callback) {
        return getItemsByFunction({
          callback: callback,
          items: items
        });
      },
      getLinkByRel: function getLinkByRel$$1(rel) {
        return getLinkByRel({
          rel: rel,
          links: links
        });
      },
      getProperty: function getProperty$$1(key) {
        return getProperty({
          key: key,
          properties: properties
        });
      },
      getPropertyMetadata: function getPropertyMetadata$$1(key) {
        return getPropertyMetadata({
          key: key,
          propertiesMetadata: propertiesMetadata
        });
      },
      href: getActionByRel({
        rel: "self",
        actions: actions
      }),
      title: getTitle(resourceRepresentation)
    };
  }

  function halNavigator(_ref) {
    var url = _ref.url,
        urlPromise = _ref.urlPromise,
        headers = _ref.headers;
    var promise = url ? createHALResourceObject(url) : urlPromise.then(function (promisedURL) {
      return createHALResourceObject(promisedURL);
    });

    function getHALResource(callback) {
      if (callback) {
        promise.then(function (res) {
          callback(res);
        });
      }
    }

    function fetchLink(rel, callback) {
      getHALResource(callback);
      return halNavigator({
        urlPromise: promise.then(function (apiResource) {
          return apiResource.getLinkByRel(rel).href;
        }),
        headers: headers
      });
    }

    function fetchItemByNumber(query, callback) {
      getHALResource(callback);
      return halNavigator({
        urlPromise: promise.then(function (apiResource) {
          return apiResource.getItemByNumber(query).href;
        }),
        headers: headers
      });
    }

    function fetchItemByFunction(findFunction, callback) {
      this.getHALResource(callback);
      return halNavigator({
        urlPromise: promise.then(function (apiResource) {
          return apiResource.getItemByFunction(findFunction).href;
        }),
        headers: headers
      });
    }

    function createHALResourceObject(resURL) {
      return req(resURL, {
        headers: headers,
        method: "get"
      }).then(function (res) {
        return res.json();
      }).then(function (getResp) {
        return getResp._options ? halResource({
          body: getResp
        }) : req(resURL, {
          headers: headers,
          method: "options"
        }).then(function (res) {
          return res.json();
        }).then(function (optionsResp) {
          return halResource({
            body: getResp,
            options: optionsResp
          });
        });
      });
    }

    return {
      fetchItemByFunction: fetchItemByFunction,
      fetchItemByNumber: fetchItemByNumber,
      fetchLink: fetchLink,
      getHALResource: getHALResource
    };
  }

  exports.halNavigator = halNavigator;
  exports.halResource = halResource;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
